import React, { useEffect, useState } from 'react';
import Immutable, { fromJS } from 'immutable';
import { useTranslation } from 'react-i18next';

import {
  Container,
  Icon,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Node,
  useViewFilterQuery,
} from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
  Pager,
} from '@uncinc/react-drupal-core/types';

import { NodeArticle } from '../../../types/uncinc_profile/nodes';
import { ButtonWrapper } from '../../../components';

import './style.scss';

interface ArticleOverviewProps {
  entities: Immutable.List<ImmutableEntity<NodeArticle>>;
  pager: Immutable.List<ImmutableEntity<Pager>>;
}

const ArticleOverview: React.FC<ArticleOverviewProps> = ({ entities, pager }) => {
  const totalPages = Number(pager.getIn(['total_pages'])) || 0;
  const { page, setCurrentPage } = useViewFilterQuery();
  const currentPage: number = Number(page) + 1;
  const { t } = useTranslation();

  const [articles, setArticles] = useState<NodeArticle[]>([]);

  useEffect(() => {
    const newArticles: NodeArticle[] = [];

    entities.forEach((entity) => {
      const articleJS = entity.toJS();

      // It's possible that the component rerenders, which would blindly append the same
      // articles to the article state.
      // This would result in articles being shown twice.
      if (!articles.find((article) => article.title[0].value === articleJS.title[0].value)) {
        newArticles.push(articleJS);
      }
    });


    setArticles((state: NodeArticle[]) => state.concat(newArticles));
  }, [entities]);

  // when load more button clicked load next page and add to array
  const loadMore = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <Container className="ViewArticlesOverview">

      {entities.size === 0 && (
        <div>
          <h3>{t('pages.search.result_empty_title')}</h3>
          <p>{t('pages.search.result_empty_body')}</p>
        </div>
      )}
      {articles.length > 0 && (
        <div className="row">
          {
            articles.map((article) => {
              const id = article.nid[0].value;
              const uuid = article.uuid[0].value;
              const langcode = article.langcode[0].value;
              const key = `${uuid}:${langcode}`;

              return (
                <Node
                  key={key}
                  id={id}
                  entity={fromJS(article)}
                  viewMode="teaser"
                />
              );
            })
          }
        </div>
      )}

      <ButtonWrapper onClick={loadMore}>
        <span>{t('general.read_more')}</span>
        <Icon name="arrow_downward" />
      </ButtonWrapper>
    </Container>
  );
};

export default ArticleOverview;
